import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import LoaderGradient from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";
import { StyledEnrichedCsvWrapper } from "app/pages/sales-intelligence/modules/enrichment/components/EnrichmentHistoryModal/components/style";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledEnrichmentHistoryContainerWrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const StyledEnrichedContentWrapper = styled(FlexColumn)``;

export const StyledModalBodyWrapper = styled(FlexColumn)`
    width: 100%;
    padding-top: 8px;
`;

export const StyledEnrichmentHistoryHeader = styled(FlexRow)`
    justify-content: space-between;
    margin-top: 24px;
`;

export const StyledEnrichmentHistoryTitle = styled.div`
    display: flex;
    align-items: center;
    ${setFontVariant("h5", colorsPalettes.carbon[400])};
`;

export const StyledEnrichmentHistoryPagination = styled.div`
    display: flex;
    justify-content: end;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;

export const StyledEnrichedItemWrapper = styled.div`
    display: flex;
    padding: 0 8px;

    ${StyledEnrichedCsvWrapper} {
        width: 100%;
    }
`;

export const StyledLoaderGradient = styled(LoaderGradient)`
    border-radius: 8px;
`;
